import PayGroup from 'components/Settings/PayrollSettings/PayGroup';

import PermissionGuard from 'components/Global/PermissionGuard';

export const PayGroupPage = () => {
	return (
		<PermissionGuard permission="Allow_Pay_Group">
			<PayGroup />
		</PermissionGuard>
	);
};
